module.exports = __webpack_public_path__ + "static/media/42_B.0b31e6ca.png";